import * as Sentry from '@sentry/nextjs';

import { SENTRY_DSN, VERSION } from './src/config';

Sentry.init({
  dsn: SENTRY_DSN,
  release: VERSION,
  tracesSampleRate: 1.0
});
